import { Icon } from '@design-system';

import { CardBrand } from '../../../Payments/CardBrand';
import { DetailsCard } from '../types';
import { formatMaskedCardNumber } from '../utils/format';

export type SavedCardCardProps = {
  card: DetailsCard;
  editLabel: string;
  onEdit: () => void;
};

export const SavedCardCard = ({
  card,
  editLabel,
  onEdit,
}: SavedCardCardProps) => (
  <button
    aria-label={editLabel}
    className="flex w-full flex-row items-center justify-between gap-3 rounded-sm border border-neutral-2 p-4 text-left"
    onClick={onEdit}
    type="button"
  >
    <div className="flex min-w-0 flex-row items-center gap-3">
      <CardBrand brand={card.brand} />
      <span className="truncate">{formatMaskedCardNumber(card.last4)}</span>
    </div>

    <Icon className="shrink-0" name="ic_edit" size="sm" />
  </button>
);
